<template>
  <carousel
    class="carousel__speakers"
    ref="carouselSelector"
    :navigationEnabled="true"
    :per-page="1"
    :perPageCustom="[
      [768, 2],
      [1024, 3],
    ]"
    :pagination-enabled="false"
    :loop="true"
    :autoplay="true"
    :autoplay-timeout="5000"
    navigationNextLabel='<img  class="banner__pass" src="/img/direita.png" />'
    navigationPrevLabel='<img  class="banner__pass" src="/img/esquerda.png" />'
  >
    <slide
      class="slide"
      align="center"
      v-for="(item, index) in items"
      :key="index"
    >
      <div
        class="banner__image"
        :style="'background-image: url(' + item.image + ')'"
      ></div>
      <div class="banner__description">
        <h6>{{ item.name }}</h6>
        <p>{{ item.mini_bio }}</p>
        <div
          class="logo-sp"
          :style="'background-image: url(' + item.logo + ')'"
        ></div>
      </div>
    </slide>
  <slide class="align-items-center justify-content-center d-flex">
      <a href="/palestrantes">
        <div class="button-carousel">
          <img src="img/cardapio.png" />
          <h5>Veja todos</h5>
          <h5>palestrantes</h5>
        </div>
      </a>
    </slide>
  </carousel>
</template>

<script>
import { Carousel, Slide } from "vue-carousel";
export default {
  props: ["items"],
  data() {
    return {
      width: screen.width,
      banner1: "http://localhost/img/rosa.png",
      banner2: "http://localhost/img/rosa2.png",
      banner3: "http://localhost/img/rony.png",
      logo1: "http://localhost/img/pessoa-marca.png",
      logo2: "http://localhost/img/camila-marca.png",
      logo3: "http://localhost/img/rony-marca.png",
    };
  },
  components: {
    Carousel,
    Slide,
  },
  methods: {
    navigateTo(index) {
      this.slider = index;
      this.$refs.carouselSelector.goToPage(index);
    },
  },
  mounted() {
    setTimeout(() => {
      this.$refs["carouselSelector"].onResize();
      this.$refs["carouselSelector"].goToPage(0);
    }, 200);
  },
};
</script>

<style lang="scss" rel="stylesheet" media="all">
@import "resources/assets/sass/website/_variables.scss";

.carousel__speakers {
  width: 100%;
  height: 100%;
  position: relative;
  @media (max-width: 756px) {
    margin-top: 0px;
    width: 80%;
    margin: 0 auto;
  }
  .slide {
    position: relative;
  }
  .banner__image {
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    position: relative;
    height: 400px;
    @media (min-width: 1500px) {
      height: 600px;
    }
    @media (min-width: 756px) {
      height: 500px;
    }
  }
  .banner__logo {
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    width: 120px;
    height: 80px;
    position: absolute;
    top: 100px;
    right: 40px;
    z-index: -1;
  }
  .banner__description {
    text-align: left;
    width: 150px;
    position: absolute;
    bottom: 0px;
    left: 30px;
    min-height: 250px;
    @media (max-width: 500px){
      min-height: 227px;
    }
    h6 {
      font-family: $font-geo;
      font-weight: bold;
      color: $green-water;
      font-size: 30px;
      line-height: 28px;
      @media (max-width: 500px) {
        font-size: 20px;
      }
    }
    p {
      font-family: $font-geo;
      color: $white;
      font-size: 16px;
      line-height: 16px;
      @media (max-width: 500px) {
        font-size: 13px;
      }
    }
    .logo-sp {
      background-repeat: no-repeat;
      background-size: contain;
      width: 150px;
      height: 50px;
    }
  }
}

.VueCarousel-navigation-next[data-v-453ad8cd]:focus {
  outline: none;
  border: none;
  box-shadow: none;
}

.banner__pass {
  margin-top: 90px;
  @media (min-width: 1500px) {
    margin-top: 100px;
  }
  @media (max-width: 996px) {
    max-width: 50px;
    max-height: 50px;
  }
  @media (max-width: 756px) {
    margin-top: 50px;
  }
  @media (max-width: 600px) {
    max-width: 30px;
    max-height: 30px;
  }
  
}
.button-carousel {
  position: relative;
  align-items: center;
  justify-content: center;
  display: flex;
  flex-direction: column;
  img {
    width: 40px;
    height: 40px;
    margin-bottom: 30px;
  }
  h5 {
    font-size: 20px;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    margin-left: 10px;
    color: white;
    text-align: center;
    &:hover {
      color: white;
    }
  }
}
</style>
